"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Form/DateInput/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);


var _time = require('shared/services/time');

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _Overlay = require('./Overlay'); var _Overlay2 = _interopRequireDefault(_Overlay);
var _Input = require('./Input'); var _Input2 = _interopRequireDefault(_Input);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

const FORMAT = 'MM/DD/YYYY'


















const OPEN_KEYS = ['Enter', ' ', 'ArrowDown']

const TABBABLE = 'input, select, textarea, button, a[href], [tabindex]'

/* The field before or after `from` in the page's tab order, leaving out the
 * calendar (it's in a layer at the end of the page) and anything disabled,
 * hidden or out of the tab order. */
const neighbourOf = (from, layer, backward) => {
  const all = [...document.querySelectorAll(TABBABLE)].filter(el => (
    el === from || (
      el.tabIndex >= 0
      && !(el ).disabled
      && (el ).type !== 'hidden'
      && !_optionalChain([layer, 'optionalAccess', _ => _.contains, 'call', _2 => _2(el)])
      && !el.closest('[hidden], [aria-hidden="true"], [inert]')
    )
  ))
  const at = all.indexOf(from)
  return at < 0 ? null : _nullishCoalesce(all[at + (backward ? -1 : 1)], () => ( null))
}

/* A date field (read-only; it shows MM/DD/YYYY) that opens a calendar on a
 * click, Enter, Space or ArrowDown. Rev 27 P4: the calendar opens in the
 * Popover layer, so a dialog never clips it; it opens on the selected day
 * (or today), and Escape or a pick goes back to the field. */
const DateInput = ({
  value,
  disabledDays,
  placeholder,
  onChange,
  isRequired,
  isDisabled,
  className,
  inputClassName,
  hasError,
  ariaLabel,
  years,
  popupClassName,
}) => {
  const rootRef = _react.useRef(null)
  const inputRef = _react.useRef(null)
  const calendarRef = _react.useRef(null)
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)

  const [displayValue, dateValue] = _react.useMemo.call(void 0, 
    () => {
      if (!value || _time.isDateNull.call(void 0, value)) return ['', null]
      const m = _moment2.default.call(void 0, value, _moment2.default.HTML5_FMT.DATE)
      return [m.format(FORMAT), m.toDate()]
    },
    [value],
  )

  const closeToField = _react.useCallback.call(void 0, 
    () => {
      setIsOpen(false)
      _optionalChain([inputRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
    },
    [],
  )

  const handleDayClick = _react.useCallback.call(void 0, 
    (date, modifiers) => {
      if (modifiers.disabled) return
      onChange(_moment2.default.call(void 0, date).format(_moment2.default.HTML5_FMT.DATE))
      closeToField()
    },
    [onChange, closeToField],
  )

  // Focus goes to the selected day, else today, else the month's first
  // day that can be picked.
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const days = calendarRef.current
      const day = _nullishCoalesce(_nullishCoalesce(_optionalChain([days, 'optionalAccess', _6 => _6.querySelector, 'call', _7 => _7('.DayPicker-Day--selected:not(.DayPicker-Day--outside)')])
, () => ( _optionalChain([days, 'optionalAccess', _8 => _8.querySelector, 'call', _9 => _9('.DayPicker-Day--today:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled)')])))
, () => ( _optionalChain([days, 'optionalAccess', _10 => _10.querySelector, 'call', _11 => _11('.DayPicker-Day:not(.DayPicker-Day--outside):not(.DayPicker-Day--disabled)')])))
      _optionalChain([day, 'optionalAccess', _12 => _12.focus, 'call', _13 => _13()])
    },
    [isOpen],
  )

  // Review R800-42: the calendar lives at the end of the page, so Tab from
  // it would skip the rest of the form. Tab closes it and goes on from the
  // field, as if the calendar weren't there; Shift+Tab goes back.
  const onCalendarKeyDown = (e) => {
    if (e.key !== 'Tab' || !inputRef.current) return
    e.preventDefault()
    setIsOpen(false)
    const next = neighbourOf(inputRef.current, calendarRef.current, e.shiftKey)
    ;(_nullishCoalesce(next, () => ( inputRef.current))).focus()
  }

  // Focus going anywhere else (a click, a script) closes it too.
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const onFocusIn = (e) => {
        const target = e.target 
        if (_optionalChain([rootRef, 'access', _14 => _14.current, 'optionalAccess', _15 => _15.contains, 'call', _16 => _16(target)]) || _optionalChain([calendarRef, 'access', _17 => _17.current, 'optionalAccess', _18 => _18.contains, 'call', _19 => _19(target)])) return
        setIsOpen(false)
      }
      document.addEventListener('focusin', onFocusIn)
      return () => document.removeEventListener('focusin', onFocusIn)
    },
    [isOpen],
  )

  const handleClear = value && !isRequired
    ? () => onChange('')
    : null

  return (
    _react2.default.createElement('div', {
      ref: rootRef,
      className: _classBuilder2.default.call(void 0, 
        'blm-date-picker',
        isDisabled && 'blm-date-picker--disabled',
        className,
      ), __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}

      , _react2.default.createElement('div', { className: "DayPickerInput", __self: this, __source: {fileName: _jsxFileName, lineNumber: 154}}
        , _react2.default.createElement(_Input2.default, {
          ref: inputRef,
          placeholder: placeholder,
          disabled: isDisabled,
          onClear: handleClear,
          hasError: hasError,
          'aria-label': ariaLabel,
          'aria-haspopup': "dialog",
          'aria-expanded': isOpen,
          className: inputClassName,
          value: displayValue,
          onClick: () => { if (!isDisabled) setIsOpen(o => !o) },
          onKeyDown: e => {
            if (isDisabled || isOpen || !OPEN_KEYS.includes(e.key)) return
            e.preventDefault()
            setIsOpen(true)
          }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        )
      )
      ,  isOpen && !isDisabled && (
        _react2.default.createElement(_Popover2.default, {
          anchorRef: rootRef,
          onClose: reason => reason === 'escape' ? closeToField() : setIsOpen(false),
          className: _classBuilder2.default.call(void 0, 'blm-date-picker blm-date-picker--layer', popupClassName),
          role: "dialog",
          'aria-label': ariaLabel ? `Choose ${ariaLabel.toLowerCase()}` : 'Choose a date', __self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}

          , _react2.default.createElement('div', { ref: calendarRef, onKeyDown: onCalendarKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}
            , _react2.default.createElement(_Overlay2.default, {
              value: dateValue,
              disabledDays: disabledDays,
              years: years,
              onChange: handleDayClick, __self: this, __source: {fileName: _jsxFileName, lineNumber: 183}}
            )
          )
        )
      )
    )
  )
}

exports. default = DateInput
